import { render, staticRenderFns } from "./popupHint.vue?vue&type=template&id=12c49506&scoped=true&"
import script from "./popupHint.vue?vue&type=script&lang=js&"
export * from "./popupHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c49506",
  null
  
)

export default component.exports